import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

const LegalRoute = lazyRouteComponent(() => import('@/features/legal/Legal'), 'Legal')

export const Route = createFileRoute('/termos')({
  component: LegalRoute,
})
